import {Action} from "redux";
import {IClientEntriesActionCreator} from "../action/client_entries_action";
import {GetAllEntriesByClientRequest} from "../request/entry_request";

interface IClientEntriesDispatcher {
    getAllEntryList(getEntryWithContractRequest: GetAllEntriesByClientRequest): void;
}

class Dispatcher implements IClientEntriesDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: IClientEntriesActionCreator) {

    }

    public getAllEntryList = (getEntryWithContractRequest: GetAllEntriesByClientRequest): void => {
        this.dispatch(this.actionCreator.requestGetAllEntriesAction(getEntryWithContractRequest));
    }

}

const createClientEntriesDispatcher = (dispatch: (action: Action) => void, actionCreator: IClientEntriesActionCreator): IClientEntriesDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {IClientEntriesDispatcher, createClientEntriesDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/client_entries_dispatcher.ts